import './App.css';
import React from 'react';
import wordlist from './wordle.json';
import Switch from "react-switch";

const WORD_LENGTH = 5;
const ALL_LETTERS = [...'qwertyuiopasdfghjklzxcvbnm'];

const HIT = '#';
const CLOSE = '+';
const MISS = '.';
const BLANK = '_';
const ALL_HIT = Array(WORD_LENGTH).fill(HIT).join('');
const ALL_BLANK = Array(WORD_LENGTH).fill(BLANK);
const CSS_CLASS = {[HIT]: 'hit', [CLOSE]: 'close', [MISS]: 'miss', [BLANK]: 'blank'};
const AIM_TO_NUMBER = {[HIT]: 40, [CLOSE]: 30, [MISS]: 20, [BLANK]: 10}; // used in higherAim

const CONFIDENT = 'confident';
const UNSURE = 'unsure';
const DISTRUST = 'distrust';

const TRUST_MORE = 'trust more';
const TRUST_LESS = 'trust less';
// const TRUST_SYMBOL = {[TRUST_MORE]: '\u2714', [TRUST_LESS]: '\u2718'};
const CSS_TRUST = {[TRUST_MORE]: 'confident', [TRUST_LESS]: 'distrust'};
// const TRUST_TEXT = {[TRUST_MORE]: "Trust", [TRUST_LESS]: "Don't Trust"}

// const TRUST_SYMBOL = {[CONFIDENT]: '\u2714', [UNSURE]: '?', [DISTRUST]: '\u2718'};
const CHECKMARK = '\u2714';
const X_MARK = '\u2718';
const TRUST_SYMBOL = {
  [CONFIDENT]: <div className='trust-symbol confident miss'>{CHECKMARK}</div>, 
  [UNSURE]: <div className='trust-symbol unsure miss'>{'?'}</div>, 
  [DISTRUST]: <div className='trust-symbol distrust'>{X_MARK}</div>};
// const CSS_TRUST = {[CONFIDENT]: 'confident', [UNSURE]: 'unsure', [DISTRUST]: 'distrust'};

const NOT_HARD_MODE = 0;
const HARD_MODE = 1;
const EVEN_HARDER_MODE = 2;

const UNSHARED = 'not shared';
const SHARE_SUCCESS = 'share success';
const SHARE_ERROR = 'share error';
const CSS_SHARE_COPY = {[UNSHARED]: 'unshared', [SHARE_SUCCESS]: 'share-success', [SHARE_ERROR]: 'share-error'};
const SHARE_COPY_CONTENT = {[UNSHARED]: 'Share', [SHARE_SUCCESS]: <em>Copied!</em>, [SHARE_ERROR]: 'Could not copy'};

// https://www.svgrepo.com/svg/361715/backspace
const BACKSPACE_ICON = (<svg width="30px" height="30px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M17.707 8.293a1 1 0 0 1 0 1.414L15.414 12l2.293 2.293a1 1 0 0 1-1.414 1.414L14 13.414l-2.293 2.293a1 1 0 0 1-1.414-1.414L12.586 12l-2.293-2.293a1 1 0 1 1 1.414-1.414L14 10.586l2.293-2.293a1 1 0 0 1 1.414 0z" /><path fillRule="evenodd" clipRule="evenodd" d="M22 5a1 1 0 0 0-1-1H9.46a2 2 0 0 0-1.519.698l-5.142 6a2 2 0 0 0 0 2.604l5.142 6A2 2 0 0 0 9.46 20H21a1 1 0 0 0 1-1V5zm-2 13H9.46l-5.143-6L9.46 6H20v12z" /></svg>);

// https://www.svgrepo.com/svg/14308/settings
// const SETTINGS_ICON = '\u2699'; 
const SETTINGS_ICON = (<svg xmlns="http://www.w3.org/2000/svg" width="22px" height="22px" x="0px" y="0px" viewBox="0 0 489.8 489.8"><path d="M469.1,182.95h-38.2c-3.1-8.3-6.2-16.6-10.3-23.8l26.9-26.9c8.3-8.2,8.3-20.6,0-28.9l-60-60c-8.2-8.3-20.6-8.3-28.9,0l-27.9,27.9c-7.2-3.1-15.5-6.2-22.7-9.3v-39.3c0-11.4-9.3-20.7-20.7-20.7h-84.8c-11.4,0-20.7,9.3-20.7,20.7v37.1c-8.2,3.1-15.5,6.2-22.7,9.3l-27.9-27.9c-8.2-8.3-20.6-8.3-28.9,0l-60,60c-8.3,8.2-8.3,20.6,0,28.9l26.9,26.9c-4.1,8.3-7.2,15.5-10.3,23.8H20.7c-11.4,0-20.7,9.3-20.7,20.7v84.8c0,11.4,9.3,20.7,20.7,20.7h35.1c3.1,8.3,6.2,16.5,10.3,24.8l-25.8,25.8c-4.1,4.1-11.6,16.3,0,28.9l60,60c8.2,8.3,20.6,8.3,28.9,0l24.8-24.8c8.2,5.2,16.5,8.3,25.8,11.4v34.1c0,11.4,9.3,20.7,20.7,20.7h84.8c11.4,0,20.7-9.3,19.7-18.5v-34.1c8.2-3.1,17.5-7.3,25.8-11.4l24.8,24.8c8.2,8.3,20.6,8.3,28.9,0l60-60c8.3-8.2,8.3-20.6,0-28.9l-25.8-25.8c4.1-8.3,7.2-16.5,10.3-24.8h40.1c11.4,0,20.7-9.3,20.7-20.7v-84.8C489.8,192.25,480.5,182.95,469.1,182.95z M445.6,266.75h-31c-9.3,0-17.5,6.2-19.6,15.5c-4.2,15.5-9.3,30-17.6,43.4c-5.2,8.3-3.1,18.6,3.1,24.8l21.7,21.7l-31,31l-20.7-20.7c-6.2-7.2-16.5-8.3-24.8-3.1c-14.5,8.3-29,14.5-44.5,18.6c-9.3,2-15.5,10.3-15.5,19.6v30h-44.5v-0.1h-1v-30c0-9.3-6.2-17.5-15.5-19.6c-15.6-4.1-31.1-10.3-44.5-18.6c-8.3-5.2-18.6-3.1-24.8,3.1l-20.7,20.7l-31-31l21.7-21.7c6.2-7.2,8.3-16.5,3.1-24.8c-8.3-13.4-14.5-27.9-17.6-43.4c-2-9.3-10.3-15.5-19.6-15.5h-31v-44.5h33.1c9.3,0,17.5-6.2,19.6-15.5c3.1-14.5,9.3-28,17.6-41.4c5.2-8.3,3.1-18.6-3.1-24.8l-23.8-23.8l31-31l23.8,23.8c7.2,6.2,16.5,8.3,24.8,3.1c13.5-7.2,26.9-13.4,41.4-16.5c9.3-2,15.5-10.3,15.5-19.6v-34.1h44.5v35.2c0,9.3,6.2,17.5,15.5,19.6c14.5,3.1,29,9.3,41.4,16.5c8.3,5.2,18.6,3.1,24.8-3.1l24.8-24.8l31,31l-23.8,23.8c-7.2,6.2-8.3,16.5-3.1,24.8c7.3,12.5,13.5,26.9,17.6,41.4c2,9.3,10.3,15.5,19.6,15.5h33.1V266.75z"/><path d="M242.9,132.25c-62,0-112.7,50.7-112.7,112.7s50.7,112.7,112.7,112.7c62.1,0,112.7-50.7,112.7-112.7S304.9,132.25,242.9,132.25z M242.9,317.35c-39.3,0-72.4-32.1-72.4-72.4c0-39.3,32.1-72.4,72.4-72.4c40.3,0,72.4,32.1,72.4,72.4C315.3,284.25,282.2,317.35,242.9,317.35z"/></svg>);

// https://www.svgrepo.com/svg/146075/question
// const INFO_ICON = (<svg xmlns="http://www.w3.org/2000/svg" width="20px" height="20px" viewBox="0 0 496.158 496.158">
// <defs>
//   <mask id="question">
// <path d="M496.158,248.085c0-137.022-111.069-248.082-248.075-248.082C111.07,0.003,0,111.063,0,248.085c0,137.001,111.07,248.07,248.083,248.07C385.089,496.155,496.158,385.086,496.158,248.085z" fill="white" />
// <path d="M138.216,173.592c0-13.915,4.467-28.015,13.403-42.297c8.933-14.282,21.973-26.11,39.111-35.486c17.139-9.373,37.134-14.062,59.985-14.062c21.238,0,39.99,3.921,56.25,11.755c16.26,7.838,28.818,18.495,37.683,31.97c8.861,13.479,13.293,28.125,13.293,43.945c0,12.452-2.527,23.367-7.581,32.739c-5.054,9.376-11.062,17.469-18.018,24.279c-6.959,6.812-19.446,18.275-37.463,34.388c-4.981,4.542-8.975,8.535-11.975,11.976c-3.004,3.443-5.239,6.592-6.702,9.447c-1.466,2.857-2.603,5.713-3.406,8.57c-0.807,2.855-2.015,7.875-3.625,15.051c-2.784,15.236-11.501,22.852-26.147,22.852c-7.618,0-14.028-2.489-19.226-7.471c-5.201-4.979-7.8-12.377-7.8-22.192c0-12.305,1.902-22.962,5.713-31.97c3.808-9.01,8.861-16.92,15.161-23.73c6.296-6.812,14.794-14.904,25.488-24.28c9.373-8.202,16.15-14.392,20.325-18.567c4.175-4.175,7.69-8.823,10.547-13.953c2.856-5.126,4.285-10.691,4.285-16.699c0-11.718-4.36-21.605-13.074-29.663c-8.717-8.054-19.961-12.085-33.728-12.085c-16.116,0-27.981,4.065-35.596,12.195c-7.618,8.13-14.062,20.105-19.336,35.925c-4.981,16.555-14.43,24.829-28.345,24.829c-8.206,0-15.127-2.891-20.764-8.679C141.035,186.593,138.216,180.331,138.216,173.592z M245.442,414.412c-8.937,0-16.737-2.895-23.401-8.68c-6.667-5.784-9.998-13.877-9.998-24.279c0-9.229,3.22-16.991,9.668-23.291c6.444-6.297,14.354-9.448,23.73-9.448c9.229,0,16.991,3.151,23.291,9.448c6.296,6.3,9.448,14.062,9.448,23.291c0,10.255-3.296,18.312-9.888,24.17C261.7,411.481,254.084,414.412,245.442,414.412z" fill="black" />
// </mask>
// </defs>
// <path d="M496.158,248.085c0-137.022-111.069-248.082-248.075-248.082C111.07,0.003,0,111.063,0,248.085c0,137.001,111.07,248.07,248.083,248.07C385.089,496.155,496.158,385.086,496.158,248.085z" mask="url(#question)" /></svg>);

// https://www.svgrepo.com/svg/32854/question-mark-in-a-circle-outline
const INFO_ICON = (<svg xmlns="http://www.w3.org/2000/svg" width="22px" height="22px" viewBox="0 0 32 32"><path d="M23.424,10.827c0,3.956-4.533,5.478-5.507,6.907c-0.729,1.063-0.485,2.557-2.495,2.557c-1.309,0-1.946-1.064-1.946-2.039c0-3.623,5.323-4.442,5.323-7.425c0-1.643-1.096-2.616-2.921-2.616c-3.895,0-2.373,4.016-5.323,4.016c-1.066,0-1.979-0.639-1.979-1.855c0-2.983,3.407-5.628,7.119-5.628C19.59,4.742,23.424,6.536,23.424,10.827z M15.545,22.268c-1.369,0-2.496,1.125-2.496,2.496c0,1.369,1.127,2.494,2.496,2.494c1.367,0,2.494-1.125,2.494-2.494C18.039,23.393,16.912,22.268,15.545,22.268z M32,16c0,8.822-7.178,16-16,16C7.178,32,0,24.822,0,16S7.178,0,16,0C24.822,0,32,7.177,32,16z M29,16c0-7.168-5.832-13-13-13S3,8.832,3,16s5.832,13,13,13S29,23.168,29,16z"/></svg>);


// https://www.svgrepo.com/svg/39319/right-arrow
// const ROW_ARROW_ICON = (<svg xmlns="http://www.w3.org/2000/svg" width="24px" viewBox="0 0 26.077 26.077"><path d="M25.709,13.552l-9.721,9.994c0,0-1.151,1.219-1.151-0.105c0-1.325,0-4.532,0-4.532s-0.781,0-1.976,0c-3.42,0-9.642,0-12.173,0c0,0-0.688,0.184-0.688-0.861c0.001-1.047,0.001-9.533,0.001-10.279S0.576,7.04,0.576,7.04c2.463,0,8.895,0,12.199,0c1.072,0,1.771,0,1.771,0s0-2.569,0-4.186c0-1.61,1.208-0.395,1.208-0.395s9.081,8.791,10.033,9.744C26.482,12.894,25.709,13.552,25.709,13.552z"/></svg>);

// https://www.svgrepo.com/svg/57141/right-arrow
const ROW_ARROW_ICON = (<svg xmlns="http://www.w3.org/2000/svg" width="24px" viewBox="0 0 490 490"><polygon points="247.773,8.081 175.407,82.05 295.118,199.145 0,199.145 0,306.14 279.496,306.14 175.407,407.949 247.773,481.919 490,245.004"/></svg>);
// const ROW_ARROW_ICON = "\u25B6";

const DARK_CONTRAST_AIM_TO_EMOJI = {
  [false]: {[false]: {[HIT]: '🟩',[CLOSE]: '🟨', [MISS]: '⬜', [BLANK]:'⬛'},
            [true]: {[HIT]: '🟧',[CLOSE]: '🟦', [MISS]: '⬛', [BLANK]:'⬜'}},
  [true]: {[false]: {[HIT]: '🟩',[CLOSE]: '🟨', [MISS]: '⬜', [BLANK]:'⬛'},
            [true]: {[HIT]: '🟧',[CLOSE]: '🟦', [MISS]: '⬛', [BLANK]:'⬜'}}
}

const LETTER_SATISFIED = "-";
const LETTER_UNSATIFIED = "!";
const ALL_SATISFIED = Array(WORD_LENGTH).fill(LETTER_SATISFIED).join('');

const CARDINAL_TO_ORDINAL_SUFFIX = ["th", "st", "nd", "rd", "th", "th", "th", "th", "th", "th"];
const TWITTER_LINK = 'https://twitter.com/intent/tweet?screen_name=wreathproduct';

const ALL_ACTUAL = wordlist['small'];
const ALL_ACTUAL_SET = new Set(ALL_ACTUAL);
const ALL_GUESSABLE = wordlist['small'].concat(wordlist['large']);
const ALL_GUESSABLE_SET = new Set(ALL_GUESSABLE);

const EST_FRAC_KEPT = 1/6;

function getDefault(obj, key, defaultValue) {
  if (key in obj) {
    return obj[key];
  } else {
    return defaultValue;
  }
}

function setDefault(obj, key, defaultValue) {
  if (!(key in obj)) {
    obj[key] = defaultValue;
  }
}

function setDefaultThenAdd(obj, key, defaultValue, summand) {
  setDefault(obj, key, defaultValue);
  obj[key] += summand;
}

// function localStorageGetDefault(key, defaultValue) {
//   const stringFromStorage = window.localStorage.getItem(key);
//   if (stringFromStorage === null) {
//     return defaultValue;
//   } else {
//     return JSON.parse(stringFromStorage);
//   }
// }

function localStorageSet(key, value) {
  window.localStorage.setItem(key, JSON.stringify(value));
}

function localStorageGetAndSetDefault(key, defaultValue) {
  const stringFromStorage = window.localStorage.getItem(key);
  if (stringFromStorage === null) {
    localStorageSet(key, defaultValue);
    return defaultValue;
  } else {
    return JSON.parse(stringFromStorage);
  }
}

function getOrdinal(n) {
  const onesDigit = (Math.abs(n) % 10);
  return (n + CARDINAL_TO_ORDINAL_SUFFIX[onesDigit]);
}

function higherAim(aim1, aim2) {
  return (AIM_TO_NUMBER[aim1] > AIM_TO_NUMBER[aim2]);
}

function computePattern(actualWord, guessedWord) {
    let scoreList = Array(WORD_LENGTH).fill(MISS)
    let actualLetterCount = {}
    let guessLetterIndices = {}
    for (const i in guessedWord) {
      const a = actualWord[i];
      const g = guessedWord[i];
      if (a === g) {
        scoreList[i] = HIT
      } else {
        // if (!(g in guessLetterIndices)) {
        //   guessLetterIndices[g] = [];
        // }
        setDefault(guessLetterIndices, g, []);
        guessLetterIndices[g].push(i);
        // if (!(a in actualLetterCount)) {
        //   actualLetterCount[a] = 0;
        // }
        // actualLetterCount[a] += 1;
        setDefaultThenAdd(actualLetterCount, a, 0, 1);
      }
    }
    for (const a in actualLetterCount) {
      const count = actualLetterCount[a];
      for (const index of (guessLetterIndices[a] ?? []).slice(0, count)) {
        scoreList[index] = CLOSE
      }
    }
    // console.log("scoreList", scoreList)
    // console.log("actualLetterCount", actualLetterCount)
    // console.log("guessLetterIndices", guessLetterIndices)
    return scoreList.join('');
}

function filterLiesLeftOnePattern(actualToLiesLeft, guessedWord, pattern) {
  if (pattern === ALL_HIT) { // just to speed things up
    return null;
  }
  const newActualToLiesLeft = {}
  for (const actualOption in actualToLiesLeft) {
    const numLeft = actualToLiesLeft[actualOption];
    const actualOptionPattern = computePattern(actualOption, guessedWord);
    if (actualOptionPattern === pattern) {
      newActualToLiesLeft[actualOption] = numLeft;
    } else {
      if (numLeft >= 1) {
        newActualToLiesLeft[actualOption] = numLeft - 1;
      }
    }
  }
  return newActualToLiesLeft;
}

function computePatternToLiesLeftToCount(actualToLiesLeft, guessedWord, isSlightlyLessStupidMode) {
  const patternToLiesLeftToDelta = {};
  const baselineLiesLeftToCount = {};
  const validPatterns = new Set()
  for (const actualOption in actualToLiesLeft) {
    const numLeft = actualToLiesLeft[actualOption];
    const actualOptionPattern = computePattern(actualOption, guessedWord);
    setDefault(patternToLiesLeftToDelta, actualOptionPattern, {});
    setDefaultThenAdd(patternToLiesLeftToDelta[actualOptionPattern], numLeft, 0, 1);
    
    if (numLeft >= 1) {
      setDefaultThenAdd(patternToLiesLeftToDelta[actualOptionPattern], numLeft - 1, 0, -1);
      setDefaultThenAdd(baselineLiesLeftToCount, numLeft - 1, 0, 1);
    }
    if (!isSlightlyLessStupidMode || ALL_ACTUAL_SET.has(actualOption)) {
      validPatterns.add(actualOptionPattern);
    }
  }

// function computePatternToLiesLeftToCount(actualToLiesLeft, guessedWord) {
//   const patternToLiesLeftToDelta = {};
//   const baselineLiesLeftToCount = {};
//   for (const actualOption in actualToLiesLeft) {
//     const numLeft = actualToLiesLeft[actualOption];
//     const actualOptionPattern = computePattern(actualOption, guessedWord);

//     // if (!(actualOptionPattern in patternToLiesLeftToDelta)) {
//     //   patternToLiesLeftToDelta[actualOptionPattern] = {}
//     // }
//     setDefault(patternToLiesLeftToDelta, actualOptionPattern, {});
//     // if (!(numLeft in patternToLiesLeftToDelta[actualOptionPattern])) {
//     //   patternToLiesLeftToDelta[actualOptionPattern][numLeft] = 0;
//     // }
//     // patternToLiesLeftToDelta[actualOptionPattern][numLeft] += 1;
//     setDefaultThenAdd(patternToLiesLeftToDelta[actualOptionPattern], numLeft, 0, 1);
    
//     if (numLeft >= 1) {
//       // if (!((numLeft - 1) in patternToLiesLeftToDelta[actualOptionPattern])) {
//       //   patternToLiesLeftToDelta[actualOptionPattern][numLeft - 1] = 0;
//       // }
//       // patternToLiesLeftToDelta[actualOptionPattern][numLeft - 1] -= 1;
//       setDefaultThenAdd(patternToLiesLeftToDelta[actualOptionPattern], numLeft - 1, 0, -1);
      
//       // if (!((numLeft - 1) in baselineLiesLeftToCount)) {
//       //   baselineLiesLeftToCount[numLeft - 1] = 0;
//       // }
//       // baselineLiesLeftToCount[numLeft - 1] += 1;
//       setDefaultThenAdd(baselineLiesLeftToCount, numLeft - 1, 0, 1);
//     }
//   }
  // console.log('baselineLiesLeftToCount', baselineLiesLeftToCount)
  // console.log('patternToLiesLeftToDelta', patternToLiesLeftToDelta)

  const patternToLiesLeftToCount = {};
  for (const actualOptionPattern in patternToLiesLeftToDelta) {
    if (validPatterns.has(actualOptionPattern)) {
      patternToLiesLeftToCount[actualOptionPattern] = {}
      for (const numLeft in baselineLiesLeftToCount) {
        patternToLiesLeftToCount[actualOptionPattern][numLeft] = baselineLiesLeftToCount[numLeft];
      }
      for (const numLeft in patternToLiesLeftToDelta[actualOptionPattern]) {
        // if (numLeft in patternToLiesLeftToCount[actualOption]) {
        //   patternToLiesLeftToCount[actualOption][numLeft] += patternToLiesLeftToDelta[actualOption][numLeft];
        // } else {
        //   patternToLiesLeftToCount[actualOption][numLeft] = patternToLiesLeftToDelta[actualOption][numLeft];
        // }
        setDefaultThenAdd(patternToLiesLeftToCount[actualOptionPattern], numLeft, 0, patternToLiesLeftToDelta[actualOptionPattern][numLeft]);
      }
    }
  }

  return patternToLiesLeftToCount;
}

function binom(n, k) {
  if (k < 0) return 0;
  if (k === 0) return 1;
  return (n / k) * binom(n - 1, k - 1);
}

function probabilityActualEndures(numLiesLeft, numTurns) {
  // console.log(probabilityActualEndures, numTurns);
  // return Math.pow(0.1, numTurns);
  let prob = 0
  for (let k = 0; k <= numLiesLeft; k++) {
    prob += binom(numTurns, k) * Math.pow(1 - EST_FRAC_KEPT, k) * Math.pow(EST_FRAC_KEPT, numTurns - k);
  }
  // console.log('probabilityActualEndures', numLiesLeft, numTurns, prob);
  return prob;
}

function estimateTurnsLeft(liesLeftToCount) {
  // console.log('liesLeftToCount', liesLeftToCount)
  let numTurns = 0;
  let totalWords = 0;
  for (const numLies in liesLeftToCount) {totalWords += liesLeftToCount[numLies];}
  if (totalWords === 1) {
    return probabilityActualEndures(0, 1);
  } else if (totalWords === 0) {
    console.log('should not reach this line; there should always be a valid word left', liesLeftToCount)
  }
  let totalProb;
  do {
    numTurns += 1;
    totalProb = 0;
    for (const numLies in liesLeftToCount) {
      const count = liesLeftToCount[numLies];
      // console.log('count', numLies, count)
      totalProb += count * probabilityActualEndures(numLies, numTurns);
    }
  } while (totalProb > 1);
  // console.log('numTurns, totalProb', numTurns, totalProb);
  return (numTurns - 1 + totalProb);
}

function choosePatternMinimizeTurns(actualToLiesLeft, guessedWord, isSlightlyLessStupidMode) {
  if (!isSlightlyLessStupidMode || ALL_ACTUAL_SET.has(guessedWord)) { // just to speed things up
    return ALL_HIT;
  }
  const patternToLiesLeftToCount = computePatternToLiesLeftToCount(actualToLiesLeft, guessedWord, isSlightlyLessStupidMode);
  // console.log('patternToLiesLeftToCount', patternToLiesLeftToCount);
  let bestEstTurnsLeft = Infinity;
  let bestPattern = null;
  // console.log("patternToLiesLeftToCount", patternToLiesLeftToCount)
  const logOptions = {}
  for (const pattern in patternToLiesLeftToCount) {
    // console.log('pattern', pattern);
    const liesLeftToCount = patternToLiesLeftToCount[pattern];
    let estTurnsLeft;
    if (pattern === ALL_HIT) {
      estTurnsLeft = 0;
    } else {
      estTurnsLeft = estimateTurnsLeft(liesLeftToCount);
    }
    logOptions[pattern]  = [estTurnsLeft, liesLeftToCount];
    if (estTurnsLeft < bestEstTurnsLeft) {
      bestEstTurnsLeft = estTurnsLeft;
      bestPattern = pattern;
    }
  }
  console.log("Choosing pattern", logOptions);
  // console.log('bestPattern', bestPattern)
  return bestPattern;
}

// class ToggleSwitch extends React.Component {
//   constructor(props) {
//     super(props);
//     this.toggleOn = this.toggleOn.bind(this);
//     this.toggleOff = this.toggleOff.bind(this);
//   }

//   render() {
//     if (this.props.isOn) {
//       <div className="toggle-switch on" onClick={this.toggleOff}>{CHECKMARK}</div>
//     } else {
//       <div className="toggle-switch off" onClick={this.toggleOn}>{X_MARK}</div>
//     }
//   }

//   toggleOn() {
//     this.props.setValue(true);
//   }

//   toggleOff() {
//     this.props.setValue(false);
//   }
// }

class Gameboard extends React.Component {
  render() {
    return (
      <div className="gameboard">
        {this.props.pastGuesses.map((wordInfo, index) => {
          const satisfaction = this.props.satisfaction;
          const lettersSatisfied = (satisfaction === null ? ALL_SATISFIED : satisfaction[index]);
          const left = (
            wordInfo.pattern === ALL_HIT 
            ? <TurnNumber turnNumber={this.props.pastGuesses.length} /> 
            : (lettersSatisfied === ALL_SATISFIED ? '' : <div className="trust-button arrow">{ROW_ARROW_ICON}</div>));
          return (
            <GameboardRow key={index} rowNum={index} wordInfo={wordInfo} relativeTrust={this.props.pastRelativeTrust[index]} trust={this.props.relativeToAbsoluteTrust[this.props.pastRelativeTrust[index]]} toggleTrust={this.props.toggleTrust} lettersSatisfied={lettersSatisfied} left={left} />
            );})}
        {this.props.isWin ? <div className="message win">Game Over! You survived {this.props.pastGuesses.length} turn{this.props.pastGuesses.length === 1 ? '' : 's'}.<br />The secret word was {this.props.pastGuesses[this.props.pastGuesses.length - 1].guessedWord.toUpperCase()}.</div> : <GameboardRow wordInfo={{guessedWord: this.props.currentGuess, pattern: ALL_BLANK}} lettersSatisfied={ALL_SATISFIED} isGivenUp={this.props.isGivenUp} left={<TurnNumber turnNumber={this.props.pastGuesses.length + 1} />} />}
        {this.props.message ? <div className="message">{this.props.message}</div> : ''}
        {this.props.isGivenUp || this.props.isWin ? <GameOverRow shareCopyStatus={this.props.shareCopyStatus} doShare={this.props.doShare} doNewGame={this.props.doNewGame} /> : ''}
      </div>
    )
  }
}

class GameboardRow extends React.Component {
  constructor(props) {
    super(props);
    this.onClick = this.onClick.bind(this);
  }

  render() {
    const guessedWord = this.props.wordInfo.guessedWord;
    // console.log('wordInfo', this.props.wordInfo)
    const pattern = this.props.wordInfo.pattern;
    // const [word, pattern] = this.props.wordInfo;
    const fullRow = [...guessedWord].concat(Array(WORD_LENGTH - guessedWord.length).fill(' '));
    // let fullPattern;
    // if (pattern.length === WORD_LENGTH) {fullPattern = pattern} else {fullPattern = ALL_BLANK}
    // console.log('isGivenUp', this.props.isGivenUp)
    return (
      <div className={"gameboard-row " + CSS_TRUST[this.props.relativeTrust] + (this.props.isGivenUp ? ' given-up' : '')} onClick={this.onClick}>
        {this.props.left ? this.props.left : <div className="trust-button" />}
        {fullRow.map((letter, index) => {return (<GameboardSquare key={index} letter={letter} letterSatisfied={this.props.lettersSatisfied[index]} aim={pattern[index]} />);})}
        {/* <TrustButton trust={this.props.trust} /> */}
        <div className="trust-button" />
      </div>
    )
  }

  onClick() {
    if (this.props.toggleTrust) {
      this.props.toggleTrust(this.props.rowNum);
    }
  }
}

class GameboardSquare extends React.Component {
  render() {
    return (
    <div className={"gameboard-square " + CSS_CLASS[this.props.aim] + (this.props.letter === ' ' ? '' : ' occupied') + (this.props.letterSatisfied === LETTER_UNSATIFIED ? ' unsatisfied' : '')}>
      <div className="gameboard-square-inner">
        {this.props.letter.toUpperCase()}
      </div>
    </div>);
  }
}

class TrustButton extends React.Component {
  render() {
    return (
      <div className="trust-button">
        {TRUST_SYMBOL[this.props.trust]}
        {/* <div className="margin-small">{TRUST_TEXT[this.props.trust]}</div> */}
      </div>)
  }
}

class TurnNumber extends React.Component {
  render() {
    return (
      <div className="trust-button">
        <div className="margin-small">Turn</div>
        <div>{this.props.turnNumber}</div>
      </div>
    );
  }
}

class GameOverRow extends React.Component {
  render() {
    return (
      <div className="game-over-row">
        <button className={"big-button " + CSS_SHARE_COPY[this.props.shareCopyStatus]} onClick={this.props.doShare}>{SHARE_COPY_CONTENT[this.props.shareCopyStatus]}</button>
        <button className="big-button" onClick={this.props.doNewGame}>New Game</button>
      </div>
    )
  }
}

class KeyboardButtonLetter extends React.Component {
  constructor(props) {
    super(props);
    this.onClick = this.onClick.bind(this);
  }
  render() {
    // const numHitByIndex = this.props.letterAim.numHitByIndex;
    // const numClose = this.props.letterAim.numClose;
    // const numMiss = this.props.letterAim.numMiss;
    // let maxHit = 0;
    // let totalClose = numClose;
    // numHitByIndex.forEach((count, index) => {
    //   if (count > maxHit) {maxHit = count;}
    //   totalClose += count;
    // })
    // let highMarks = {1: BLANK, 2: BLANK}
    // for (const threshold in highMarks) {
    //   if (maxHit >= threshold) {highMarks[threshold] = HIT;}
    //   else if (totalClose >= threshold) {highMarks[threshold] = CLOSE;}
    //   else if (numMiss >= threshold) {highMarks[threshold] = MISS;}
    // }

    // return <button className={"keyboard-button letter " + CSS_CLASS[highMarks[2]]} value={this.props.letter} onClick={this.onClick}>
    //   <div className={"keyboard-button-inner letter " + CSS_CLASS[highMarks[1]]}>{this.props.letter.toUpperCase()}</div>
    // </button>;

    const letterAim = this.props.letterAim;
    return <button className={"keyboard-button letter " + CSS_CLASS[letterAim[1]]} value={this.props.letter} onClick={this.onClick}>
      <div className={"keyboard-button-inner letter " + CSS_CLASS[letterAim[0]]}>{this.props.letter.toUpperCase()}</div>
    </button>;
  }

  onClick() {
    this.props.typeLetter(this.props.letter);
  }
}

class KeyboardExplainerRow extends React.Component {
  render() {
    return (<div className="keyboard-explainer-row">
      <div className="keyboard-explainer-letter-wrapper">
      <KeyboardButtonLetter letter={this.props.letter} typeLetter={() => {}} letterAim={this.props.letterAim} />
      </div>
      <div className="keyboard-explainer-text">{this.props.children}</div>
    </div>)
  }
}

class KeyboardButtonWide extends React.Component {
  render() {
    return (<button className="keyboard-button wide" value={this.props.value} onClick={this.props.onClick}>
      {this.props.text}
    </button>);
  }
}

class KeyboardRow extends React.Component {
  render() {
    return (
      <div className="keyboard-row">
        {this.props.first}
        {[...this.props.letters].map((letter) => 
          <KeyboardButtonLetter key={letter} letter={letter} typeLetter={this.props.typeLetter} letterAim={this.props.keyboardAim[letter]} />)}
        {this.props.last}
      </div>
    );
  }
}

class Keyboard extends React.Component {
  render() {
    const enterButton = <KeyboardButtonWide value="enter" text="ENTER" onClick={this.props.tryEnter} />; 
    const backspaceButton = <KeyboardButtonWide value="backspace" text={this.props.canUndoWord ? "UNDO GUESS" : BACKSPACE_ICON} onClick={this.props.typeBackspace} />; 
    return (
      <div className="keyboard">
        <KeyboardRow letters="qwertyuiop" typeLetter={this.props.typeLetter} keyboardAim={this.props.keyboardAim} />
        <KeyboardRow letters="asdfghjkl" typeLetter={this.props.typeLetter} keyboardAim={this.props.keyboardAim} />
        <KeyboardRow letters="zxcvbnm" typeLetter={this.props.typeLetter} keyboardAim={this.props.keyboardAim} first={enterButton} last={backspaceButton} />
      </div>
    )
  }
}

class GameHeader extends React.Component {
  constructor(props) {
    super(props);
    this.setShowSettingsTrue = this.setShowSettingsTrue.bind(this);
    this.setShowRulesTrue = this.setShowRulesTrue.bind(this);
  }

  render() {
    return (
      <header className="game-header">
        <button className="game-header-button" value="show-rules" onClick={this.setShowRulesTrue}>{INFO_ICON}</button>
        <div className="game-header-title"><div>ABSURVIVLE</div></div>
        <button className="game-header-button" value="show-settings" onClick={this.setShowSettingsTrue}>{SETTINGS_ICON}</button>
      </header>
    )
  }
  
  setShowSettingsTrue() {
    this.props.setShowSettings(true);
  }

  setShowRulesTrue() {
    this.props.setShowRules(true);
  }
}


class RulesModal extends React.Component {
  constructor(props) {
    super(props);
    this.setShowRulesFalse = this.setShowRulesFalse.bind(this);
  }
  render() {
    return (
      <div className={"modal " + (this.props.showRules ? "show" : "hide")}>
        <div className="main-column">
          <div className="modal-header">
            <div className="modal-close-button" />
            <div className="modal-title">How to Play</div>
            <button className="modal-close-button" value="close-rules" onClick={this.setShowRulesFalse}>&times;</button>
          </div>
          <div className="modal-content">
            <p><a href="https://lazyguyy.github.io/survivle/" target="_blank" rel="noreferrer"><strong>Survivle</strong></a> (by lazyguyy) is like <a href="https://www.nytimes.com/games/wordle/index.html" target="_blank" rel="noreferrer">Wordle</a> (by Josh Wardle) except you are trying to <em>not</em> guess the secret word. You play in an extra-hard mode where you are required to use all previous information.</p> 
            <p><a href="https://qntm.org/files/absurdle/absurdle.html" target="_blank" rel="noreferrer"><strong>Absurdle</strong></a> (by qntm) is like Wordle, except the computer gets to choose the word adversarially, retroactively choosing the word that is worst for your strategy.</p>
            <p>I have combined <strong>Absurdle</strong> and <strong>Survivle</strong> into <strong>Absurvivle</strong>.</p>
            <p>You are trying to not guess the secret word. But the computer can choose its word adversarially.</p>
            <p>Good luck with that.</p>
            <div className="settings-row">
              <button className="big-button" onClick={this.setShowRulesFalse}>Play Now!</button>
            </div>
          </div>
        </div>
      </div>
    )
  }

  setShowRulesFalse() {
    this.props.setShowRules(false);
  }
}

class SettingsModal extends React.Component {
  constructor(props) {
    super(props);
    this.setShowSettingsFalse = this.setShowSettingsFalse.bind(this);
  }
  render() {
    const atLeastHardMode = (this.props.whichHardMode === HARD_MODE || this.props.whichHardMode === EVEN_HARDER_MODE);
    return (
      <div className={"modal " + (this.props.showSettings ? "show" : "hide")}>
        <div className="main-column">
          <div className="modal-header">
            <div className="modal-close-button" />
            <div className="modal-title">Settings</div>
            <button className="modal-close-button" value="close-settings" onClick={this.setShowSettingsFalse}>&times;</button>
          </div>
          <div className="modal-content">
            <div className="settings-row">
              <button className="big-button" onClick={this.props.doGiveUp}>Give Up</button>
              <button className="big-button" onClick={this.props.doNewGame}>New Game</button>
            </div>
            {/* {this.props.maxLiesAddMessage ? <div className="message max-lies-add-message">{this.props.maxLiesAddMessage}</div> : null}
            <OneSetting name="Number of Lies" control={<NumberInput value={this.props.maxLies} add={this.props.maxLiesAdd} off={!this.props.isNewGame} />} >
              The computer is allowed to lie (give you incorrect colors) in response to this many guesses.
            </OneSetting>
            <OneSettingSwitch name="Hard Mode" onChange={this.props.toggleHardMode} checked={atLeastHardMode} extraClassNames={(atLeastHardMode ? " continues" : null)}>
              If a letter must be in the secret word (because you've received multiple clues about it, more than the number of lies), then it must be in your future guesses.
            </OneSettingSwitch>
            {(atLeastHardMode
              ?
                <div className="settings-row">
                  <OneSettingSwitch name="Even Harder Mode" onChange={this.props.toggleEvenHarderMode} checked={this.props.whichHardMode === EVEN_HARDER_MODE} extraClassNames=" continued">
                    Every guess must be a valid possibility for the secret word &mdash; your guess can't contradict multiple past clues (more than the number of lies).
                  </OneSettingSwitch>
                </div>
              : null)}
            <OneSettingSwitch name="Fancy keyboard coloring" onChange={this.props.toggleUseFancyTrust} checked={this.props.useFancyTrust}>
              <strong>Basic keyboard:</strong> Each letter on the keyboard is colored based on what you know about it. It assumes that every clue is accurate, but you can tap on a clue to mark it as a lie. <br />
              <strong>Fancy keyboard:</strong> Fully colored letters show information that is certain. Information that might be a lie is marked with a dot.
            </OneSettingSwitch> */}
            <OneSettingSwitch name="Dark Mode" onChange={this.props.toggleDarkMode} checked={this.props.useDarkMode}>
              
            </OneSettingSwitch>
            <OneSettingSwitch name="High-Contrast Colors" onChange={this.props.toggleHighContrast} checked={this.props.useHighContrast}>
              
            </OneSettingSwitch>
            <OneSettingSwitch name="Slightly less stupid mode" onChange={this.props.toggleSlightlyLessStupidMode} checked={this.props.isSlightlyLessStupidMode}>
              You can guess any word in a list of about 12000 words, but the computer can only choose its secret word from a shorter list of about 2000 words. So you might actually get more than one turn.
            </OneSettingSwitch>
            <OneSetting name="Feedback" control={<a href={TWITTER_LINK} target="blank">Twitter</a>}>

            </OneSetting>
            <div className="spacer"></div>
            <div className="version-row"><div className="left">&copy;2022 Timothy Black</div><div className="right">v1</div></div>
          </div>
        </div>
      </div>
    )
  }

  setShowSettingsFalse() {
    this.props.setShowSettings(false);
  }
}

class OneSetting extends React.Component {
  render() {
    return (
      <div className={"settings-row" + (this.props.extraClassNames ? this.props.extraClassNames : '')}>
        <label>
          <div className="setting-label">
            <div className="setting-name">{this.props.name}</div>
            <div className="setting-description">{this.props.children}</div>
          </div>
          {this.props.control}
        </label>
      </div>
    )
  }
}

class OneSettingSwitch extends React.Component {
  render() {
    const control = (
      <Switch className="switch" onChange={this.props.onChange} checked={this.props.checked} onColor="#6aaa64" width={56} height={28} />
    )
    return (
      <OneSetting name={this.props.name} control={control} extraClassNames={this.props.extraClassNames}>
        {this.props.children}
      </OneSetting>
    )
  }
}

class NumberInput extends React.Component {
  constructor(props) {
    super(props);
    this.decrement = this.decrement.bind(this);
    this.increment = this.increment.bind(this);
  }
  render() {
    const value = this.props.value;
    return (
      <div className="number-input">
        <button className={(value === 0 || this.props.off) ? "off" : ""} onClick={this.decrement}>-</button>
        <div className="number-input-value">{value}</div>
        <button className={this.props.off ? "off" : ""} onClick={this.increment}>+</button>
      </div>
    );
  }

  decrement() {
    this.props.add(-1);
  }

  increment() {
    this.props.add(1);
  }
}

class App extends React.Component {
  constructor(props) {
    super(props);
    // let useDarkMode;
    // const localStorageDarkMode = localStorageGetDefault('useDarkMode', null);
    // if (localStorageDarkMode === null) {
    //   const isDeviceDark = window.matchMedia('(prefers-color-scheme: dark)').matches;
    //   localStorageSet('useDarkMode', isDeviceDark);
    //   useDarkMode = isDeviceDark;
    // } else {
    //   useDarkMode = localStorageDarkMode;
    // }
    // settings
    const isAbsurd = true;
    const showRulesOnStart = localStorageGetAndSetDefault('showRulesOnStart', true);
    // const maxLies = localStorageGetAndSetDefault('maxLies', 1);
    const maxLies = 0;
    // const whichHardMode = localStorageGetAndSetDefault('whichHardMode', NOT_HARD_MODE);
    const whichHardMode = EVEN_HARDER_MODE;
    // const useFancyTrust = localStorageGetAndSetDefault('useFancyTrust', true);
    const useFancyTrust = false;
    const useDarkMode = localStorageGetAndSetDefault('useDarkMode', window.matchMedia('(prefers-color-scheme: dark)').matches);
    const useHighContrast = localStorageGetAndSetDefault('useHighContrast', false);
    const isSlightlyLessStupidMode = localStorageGetAndSetDefault('isSlightlyLessStupidMode', false);
    // const useDarkMode = isDeviceDark;

    // const pastGuesses = [];
    // const keyboardAim = this.computeKeyboardAim(pastGuesses);
    this.state = {
      // settings
      isAbsurd: isAbsurd,
      maxLies: maxLies,
      whichHardMode: whichHardMode,
      useFancyTrust: useFancyTrust,
      useDarkMode: useDarkMode,
      useHighContrast: useHighContrast,
      isSlightlyLessStupidMode: isSlightlyLessStupidMode,

      // modal
      showRules: showRulesOnStart,
      showSettings: false,
    };

    // game-specific data
    // const actualToLiesLeft = {};
    // ALL_ACTUAL.forEach((actualOption) => {
    //   actualToLiesLeft[actualOption] = maxLies;
    // });
    // const actualToLiesLeft = null;
    // let actualWord = null;
    // if (!isAbsurd) {
    //   actualWord = ALL_ACTUAL[Math.floor(Math.random() * ALL_ACTUAL.length)];
    // }
    // const gameSpecificState = {
    //   pastGuesses: [], 
    //   pastRelativeTrust: [], 
    //   // relativeToAbsoluteTrust: this.computeRelativeToAbsoluteTrust(useFancyTrust, [], maxLies),
    //   currentGuess: '', 
    //   actualToLiesLeft: actualToLiesLeft,
    //   actualWord: actualWord, 
    //   message: '',
    //   satisfaction: null,
    // }
    // Object.assign(this.state, gameSpecificState);
    Object.assign(this.state, getGameSpecficStateStandalone(isAbsurd));
    // this.setState(gameSpecificState);
    // this.bottomElement = React.createRef();
    this.doGiveUp = this.doGiveUp.bind(this);
    this.doNewGame = this.doNewGame.bind(this);
    this.doShare = this.doShare.bind(this);
    this.handleKeydown = this.handleKeydown.bind(this);
    // this.handleScroll = this.handleScroll.bind(this);
    this.scrollToBottom = this.scrollToBottom.bind(this);
    this.typeLetter = this.typeLetter.bind(this);
    this.typeBackspace = this.typeBackspace.bind(this);
    this.typeEscape = this.typeEscape.bind(this);
    this.tryEnter = this.tryEnter.bind(this);
    this.toggleTrust = this.toggleTrust.bind(this);
    this.setShowRules = this.setShowRules.bind(this);
    this.setShowSettings = this.setShowSettings.bind(this);
    // this.computeKeyboardAim = this.computeKeyboardAim.bind(this);
    this.computeKeyboardAim = miniMemo(computeKeyboardAimStandalone);
    this.computeRelativeToAbsoluteTrust = miniMemo(this.computeRelativeToAbsoluteTrust);

    // toggle settings functions
    this.toggleUseFancyTrust = this.toggleUseFancyTrust.bind(this);
    this.toggleDarkMode = this.toggleDarkMode.bind(this);
    this.toggleHighContrast = this.toggleHighContrast.bind(this);
    this.toggleHardMode = this.toggleHardMode.bind(this);
    this.toggleEvenHarderMode = this.toggleEvenHarderMode.bind(this);
    this.toggleSlightlyLessStupidMode = this.toggleSlightlyLessStupidMode.bind(this);
    this.maxLiesAdd = this.maxLiesAdd.bind(this);
  }

  doGiveUp() {
    this.setState((state) => {
      if (checkWinStandalone(state.pastGuesses)) {
        return {
          showSettings: false,
          shareCopyStatus: UNSHARED,
        };
      } else {
        const actualToLiesLeft = state.actualToLiesLeft;
        let bestActual;
        let numWordsRemaining;
        if (actualToLiesLeft === null) {
          bestActual = ALL_ACTUAL[0];
          numWordsRemaining = ALL_ACTUAL.length;
        } else {
          bestActual = Array(WORD_LENGTH).fill('?').join('');
          let bestNumLiesLeft = -1;
          numWordsRemaining = 0;
          for (const actualOption in actualToLiesLeft) {
            const numLiesLeft = actualToLiesLeft[actualOption];
            if (ALL_ACTUAL_SET.has(actualOption) && numLiesLeft > bestNumLiesLeft) {
              bestActual = actualOption;
              bestNumLiesLeft = numLiesLeft;
            }
            numWordsRemaining += 1;
          }
        }
        const [/*numUnsatisfied*/, actualSatisfaction] = computeSatisfactionStandalone(bestActual, state.pastGuesses);
        return {
          showSettings: false,
          message: <span>{'You gave up after ' + state.pastGuesses.length + ' turn' + (state.pastGuesses.length === 1 ? '' : 's') + '.'}<br />{'The secret word was ' + bestActual.toUpperCase() + '.'}</span>,
          maxLiesAddMessage: '',
          satisfaction: actualSatisfaction,
          shareCopyStatus: UNSHARED,
          currentGuess: bestActual,
          isGivenUp: true,
        };
      }
    },
    this.scrollToBottom)
  }

  doNewGame() {
    this.setState((state) => {
      const gameSpecificState = getGameSpecficStateStandalone(state.isAbsurd);
      gameSpecificState.showSettings = false;
      return gameSpecificState;
    })
  }

  doShare() {
    const gameBoardEmoji = getGameboardEmoji(this.state.pastGuesses, this.state.useDarkMode, this.state.useHighContrast);
    const isWin = checkWinStandalone(this.state.pastGuesses);
    // console.log("isWin", isWin);
    let allSatisfiesHardHarderMode = NOT_HARD_MODE;
    if (isWin) {
      if (checkAllSatisfiesHardHarderModeStandalone(this.state.pastGuesses, HARD_MODE, this.state.maxLies)) {
        // console.log("passed hard");
        allSatisfiesHardHarderMode = HARD_MODE
        if (checkAllSatisfiesHardHarderModeStandalone(this.state.pastGuesses, EVEN_HARDER_MODE, this.state.maxLies)) {
          allSatisfiesHardHarderMode = EVEN_HARDER_MODE
        }
      }
    }
    // console.log("allSatisfiesHardHarderMode", allSatisfiesHardHarderMode)
    let text = "Absurvivle: Survived " + this.state.pastGuesses.length + " turn" + (this.state.pastGuesses.length === 1 ? "" : "s") + "\n";
    // text +=  "🤥 " + (this.state.maxLies === 1 ? "One lie" : this.state.maxLies + " lies") + "\n";
    // text += {[NOT_HARD_MODE]: '', [HARD_MODE]: '⛰️ Hard Mode\n', [EVEN_HARDER_MODE]: '🌋 Even Harder Mode\n'}[allSatisfiesHardHarderMode];
    text += (this.state.isSlightlyLessStupidMode ? "Slightly less stupid mode\n" : "")
    text += '\n';
    text += gameBoardEmoji;
    text += "\nhttps://www.timblack.net/absurvivle/\n";
    text += "#absurvivle";
    // if ('clipboard' in navigator) {
      navigator.clipboard.writeText(text).then(
        // () => {alert("Copied to clipboard");},
        () => {this.setState({shareCopyStatus: SHARE_SUCCESS,});},
        (err) => {
          console.log("Could not copy to clipoboard: " + err);
          this.setState({shareCopyStatus: SHARE_ERROR,});
        }
      )
      // navigator.share({
      //   title: "Absurdliar",
      //   text: "Solved",
      //   url: "absurdliar.example.com",
      // })
    // } else {
    //   const success = document.execCommand('copy', true, text);
    //   if (success) {
    //     this.setState({shareCopyStatus: SHARE_SUCCESS,});
    //   } else {
    //     this.setState({shareCopyStatus: SHARE_ERROR,});
    //   }
    //   // this.setState({shareCopyStatus: SHARE_ERROR,});
    // }
  }

  componentDidMount() {
    window.addEventListener("keydown", this.handleKeydown);
    // window.addEventListener("scroll", this.handleScroll);
  }

  componentWillUnmount() {
    window.removeEventListener("keydown", this.handleKeydown)
    // window.removeEventListener("scroll", this.handleScroll);
  }

  handleKeydown(event) {
    const lowerKey = event.key.toLowerCase();
    if (lowerKey.length === 1 && 'a' <= lowerKey && lowerKey <= 'z') {
      this.typeLetter(lowerKey);
    } else if (lowerKey === 'backspace') {
      this.typeBackspace();
    } else if (lowerKey === 'escape') {
      this.typeEscape();
    } else if (lowerKey === 'enter' || lowerKey === 'return') {
      this.tryEnter();
    }
  }

  typeLetter(letter) {
    // console.log(letter)
    this.setState((state) => {
      const currentGuess = state.currentGuess;
      if (currentGuess.length < WORD_LENGTH && !(checkWinStandalone(state.pastGuesses)))
        return {currentGuess: currentGuess + letter};
      else
        return {};
    })
  }

  typeBackspace() {
    this.setState((state) => {
      const currentGuess = state.currentGuess;
      const pastGuesses = state.pastGuesses;
      const pastRelativeTrust = state.pastRelativeTrust;
      if (state.isGivenUp) {
        return {
          message: '',
          maxLiesAddMessage: '',
          satisfaction: null,
          shareCopyStatus: UNSHARED,
          isGivenUp: false,
        };
      }
      else if (currentGuess.length > 0) {
        return {
          currentGuess: currentGuess.slice(0, -1),
          message: '',
          maxLiesAddMessage: '',
          satisfaction: null,
          shareCopyStatus: UNSHARED,
          isGivenUp: false,
        };
      } else if (pastGuesses.length > 0) {
        const lastWord = pastGuesses[pastGuesses.length - 1].guessedWord;
        const actualToLiesLeft = pastGuesses[pastGuesses.length - 1].actualToLiesLeft;
        return {currentGuess: lastWord,
                actualToLiesLeft: actualToLiesLeft,
                pastGuesses: pastGuesses.slice(0, -1),
                pastRelativeTrust: pastRelativeTrust.slice(0, -1),
                message: '',
                maxLiesAddMessage: '',
                satisfaction: null,
                shareCopyStatus: UNSHARED,
                isGivenUp: false,
              };
      } else {
        return {
          message: '',
          maxLiesAddMessage: '',
          satisfaction: null,
          shareCopyStatus: UNSHARED,
          isGivenUp: false,
        };
      }
    })
  }

  typeEscape() {
    if (this.state.showRules) {
      this.setShowRules(false);
    }
    if (this.state.showSettings) {
      this.setShowSettings(false);
    }
  }

  tryEnter() {
    this.setState((state) => {
      const currentGuess = state.currentGuess;
      const pastGuesses = state.pastGuesses;
      const pastRelativeTrust = state.pastRelativeTrust;
      const isSlightlyLessStupidMode = state.isSlightlyLessStupidMode;
      const isGivenUp = state.isGivenUp;
      if (currentGuess.length === WORD_LENGTH && !isGivenUp) {
        if (ALL_GUESSABLE_SET.has(currentGuess)) {
          let pattern;
          const [satisfiesHardMode, satisfaction, message] = checkHardHarderModeStandalone(currentGuess, pastGuesses, state.whichHardMode, state.maxLies);
          if (satisfiesHardMode) {
            let outgoingActualToLiesLeft;
            if (state.actualToLiesLeft === null) {
              outgoingActualToLiesLeft = {};
              // console.log("maxLies", state.maxLies);
              ALL_GUESSABLE.forEach((actualOption) => {
                outgoingActualToLiesLeft[actualOption] = state.maxLies;
              });
              // console.log("anew", outgoingActualToLiesLeft);
            } else {
              outgoingActualToLiesLeft = state.actualToLiesLeft;
            }
            if (state.isAbsurd) {
              pattern = choosePatternMinimizeTurns(outgoingActualToLiesLeft, currentGuess, isSlightlyLessStupidMode);
            } else {
              pattern = computePattern(state.actualWord, currentGuess);
            }
            const newActualToLiesLeft = filterLiesLeftOnePattern(outgoingActualToLiesLeft, currentGuess, pattern);
            console.log(currentGuess, newActualToLiesLeft);
            const newPastGuesses = [...pastGuesses, {guessedWord: currentGuess, pattern: pattern, actualToLiesLeft: state.actualToLiesLeft}];
            const newIsWin = checkWinStandalone(newPastGuesses);
            const [/*numUnsatisfied*/, newSatisfaction] = (newIsWin ? computeSatisfactionStandalone(currentGuess, newPastGuesses) : [null, null]);
            // console.log(newSatisfaction);
            return {pastGuesses: newPastGuesses,
                    pastRelativeTrust: [...pastRelativeTrust, TRUST_MORE],
                    currentGuess: '',
                    actualToLiesLeft: newActualToLiesLeft,
                    message: '',
                    maxLiesAddMessage: '',
                    satisfaction: newSatisfaction,
                    shareCopyStatus: UNSHARED,
                    isGivenUp: false,};
          } else { // not satisfiesHardMode
            return {
              message: message,
              maxLiesAddMessage: '',
              satisfaction: satisfaction,
              shareCopyStatus: UNSHARED,
              isGivenUp: false,
            };
          }
        } else { // not in word list
          return {
            message: 'Not in word list',
            maxLiesAddMessage: '',
            satisfaction: null,
            shareCopyStatus: UNSHARED,
            isGivenUp: false,
          };
        }
      } else {
        return {};
      }
    },
    this.scrollToBottom);
  }

  toggleTrust(rowNum) {
    // // console.log('toggleTrust', rowNum)
    // this.setState((state) => {
    //   const oldRelativeTrust = state.pastRelativeTrust[rowNum];
    //   let newRelativeTrust;
    //   if (oldRelativeTrust === TRUST_LESS) {
    //     newRelativeTrust = TRUST_MORE;
    //   } else if (oldRelativeTrust === TRUST_MORE) {
    //     newRelativeTrust = TRUST_LESS;
    //   } else {
    //     console.log("should not reach this line");
    //   }
    //   let newPastRelativeTrust = [...state.pastRelativeTrust];
    //   newPastRelativeTrust[rowNum] = newRelativeTrust;
    //   // console.log(state.pastRelativeTrust, newPastRelativeTrust)
      
    //   // // Yeah so I'm computing relativeToAbsoluteTrust each time a trust is toggled instead of on the fly; maybe that will catch up with me.
    //   // const relativeToAbsoluteTrust = this.computeRelativeToAbsoluteTrust(state.useFancyTrust, newPastRelativeTrust, state.maxLies);
    
    //   return {pastRelativeTrust: newPastRelativeTrust,
    //           // relativeToAbsoluteTrust: relativeToAbsoluteTrust
    //         };
    // })
    // // this.setState((state) => {
    // //   const oldTrust = state.pastTrust[rowNum];
    // //   let newRelativeTrust;
    // //   if (oldTrust === UNSURE) {
    // //     newTrust = CONFIDENT;
    // //   } else if (oldTrust === CONFIDENT) {
    // //     newTrust = DISTRUST;
    // //   } else if (oldTrust === DISTRUST) {
    // //     newTrust = UNSURE;
    // //   } else {
    // //     console.log("should not reach this line");
    // //   }
    // //   let newPastTrust = [...state.pastTrust];
    // //   newPastTrust[rowNum] = newTrust;
    // //   // console.log(state.pastTrust, newPastTrust)
    // //   return {pastTrust: newPastTrust};
    // // })
  }

  setShowRules(newShowRules) {
    this.setState({
      showRules: newShowRules,
      maxLiesAddMessage: '',
      shareCopyStatus: UNSHARED,
    });
    if (!newShowRules) {
      localStorageSet('showRulesOnStart', false);
    }
  }
    
  setShowSettings(newShowSettings) {
    this.setState({
      showSettings: newShowSettings,
      maxLiesAddMessage: '',
      shareCopyStatus: UNSHARED,
    });
  }
  // this.setState({showSettings: newShowSettings}, this.scrollToBottom);

  computeRelativeToAbsoluteTrust(useFancyTrust, pastRelativeTrust, maxLies) { // does not use "this"
    if (useFancyTrust) {
      let numTrustLess = 0;
      pastRelativeTrust.forEach((relativeTrust) => {
        if (relativeTrust === TRUST_LESS) {
          numTrustLess += 1;
        }
      })
      const relativeToAbsoluteTrust = {};
      if (numTrustLess < maxLies) {  // should be maxLies
        relativeToAbsoluteTrust[TRUST_MORE] = UNSURE;
      } else {
        relativeToAbsoluteTrust[TRUST_MORE] = CONFIDENT;
      }
      if (numTrustLess <= maxLies) {  // should be maxLies
        relativeToAbsoluteTrust[TRUST_LESS] = DISTRUST;
      } else {
        relativeToAbsoluteTrust[TRUST_LESS] = UNSURE;
      }
      return [relativeToAbsoluteTrust, numTrustLess];
    } else {
      return [{[TRUST_MORE]: CONFIDENT, [TRUST_LESS]: DISTRUST}, null];
    }
  }

  scrollToBottom() {
    // this.bottomElement.scrollIntoView({behavior: "auto"});
  }

  render() {
    const isWin = checkWinStandalone(this.state.pastGuesses);
    const [relativeToAbsoluteTrust, numTrustLess] = this.computeRelativeToAbsoluteTrust(this.state.useFancyTrust, this.state.pastRelativeTrust, this.state.maxLies);
    const keyboardAim = this.computeKeyboardAim(this.state.pastGuesses, this.state.pastRelativeTrust, relativeToAbsoluteTrust, numTrustLess, this.state.maxLies);
    const isNewGame = checkNewGameStandalone(this.state.pastGuesses);
    // const isGameOver = isWin || this.state.isGivenUp;
    // console.log('showSettings', this.state.showSettings);
    return (
      <div className={"App" + (this.state.useDarkMode ? " dark-mode" : "") + (this.state.useHighContrast ? " high-contrast" : "")}>
        {/* <div className={"App-header " + (this.state.showSettings ? "hide" : "show")}> */}
        <div className="App-header">
          <div className="main-column">
            <GameHeader maxLies={this.state.maxLies} setShowRules={this.setShowRules} setShowSettings={this.setShowSettings} />
            <div className="main-area">
              <Gameboard pastGuesses={this.state.pastGuesses} pastRelativeTrust={this.state.pastRelativeTrust} relativeToAbsoluteTrust={relativeToAbsoluteTrust} currentGuess={this.state.currentGuess} isGivenUp={this.state.isGivenUp} isWin={isWin} message={this.state.message} satisfaction={this.state.satisfaction} toggleTrust={this.toggleTrust} shareCopyStatus={this.state.shareCopyStatus} doShare={this.doShare} doNewGame={this.doNewGame} />
            </div>
            <Keyboard keyboardAim={keyboardAim} typeLetter={this.typeLetter} tryEnter={this.tryEnter} typeBackspace={this.typeBackspace} canUndoWord={this.state.currentGuess === "" && this.state.pastGuesses.length > 0}/>
            <div className="bottom-element" ref={(el) => {this.bottomElement = el;}}></div>
            {/* <SaveRelativeToAbsoluteTrust pastGuesses={this.state.pastGuesses} /> */}
          </div>
        </div>
        {this.state.showRules ?
          <RulesModal
            showRules={this.state.showRules} setShowRules={this.setShowRules}
          />
          :
          null
        }
        <SettingsModal
          doGiveUp={this.doGiveUp} doNewGame={this.doNewGame}
          showSettings={this.state.showSettings} setShowSettings={this.setShowSettings}
          useFancyTrust={this.state.useFancyTrust} toggleUseFancyTrust={this.toggleUseFancyTrust} 
          useDarkMode={this.state.useDarkMode} toggleDarkMode={this.toggleDarkMode} 
          useHighContrast={this.state.useHighContrast} toggleHighContrast={this.toggleHighContrast} 
          whichHardMode={this.state.whichHardMode} toggleHardMode={this.toggleHardMode} toggleEvenHarderMode={this.toggleEvenHarderMode}
          maxLies={this.state.maxLies} maxLiesAdd={this.maxLiesAdd} maxLiesAddMessage={this.state.maxLiesAddMessage} isNewGame={isNewGame}
          isSlightlyLessStupidMode={this.state.isSlightlyLessStupidMode} toggleSlightlyLessStupidMode={this.toggleSlightlyLessStupidMode}
        />
      </div>
    );
  }

  
  // toggle settings functions
  toggleUseFancyTrust(checked) {
    // console.log('toggleUseFancyTrust', checked);
    // this.setState((state) => {
    //   return {useFancyTrust: checked,
    //           // relativeToAbsoluteTrust: this.computeRelativeToAbsoluteTrust(checked, state.pastRelativeTrust, state.maxLies),
    //          };
    // });
    this.setState({useFancyTrust: checked},
      () => {localStorageSet('useFancyTrust', checked);}
    );
  }

  
  toggleSlightlyLessStupidMode(checked) {
    this.setState({isSlightlyLessStupidMode: checked}, 
      () => {localStorageSet('isSlightlyLessStupidMode', checked);}
    );
  }

  toggleDarkMode(checked) {
    this.setState({useDarkMode: checked},
      () => {localStorageSet('useDarkMode', checked);}
    );
  }

  toggleHighContrast(checked) {
    this.setState({useHighContrast: checked},
      () => {localStorageSet('useHighContrast', checked);}
    );
  }

  toggleHardMode(checked) { // still need to make dependent on whether it's a new game
    if (checked) {
      this.setState({whichHardMode: HARD_MODE},
        () => {localStorageSet('whichHardMode', HARD_MODE);}
      );
    } else {
      this.setState({whichHardMode: NOT_HARD_MODE},
        () => {localStorageSet('whichHardMode', NOT_HARD_MODE);}
      );
    }
  }
  
  toggleEvenHarderMode(checked) { // still need to make dependent on whether it's a new game
    if (checked) {
      this.setState({whichHardMode: EVEN_HARDER_MODE},
        () => {localStorageSet('whichHardMode', EVEN_HARDER_MODE);}
      );
    } else {
      this.setState({whichHardMode: HARD_MODE},
        () => {localStorageSet('whichHardMode', HARD_MODE);}
      );
    }
  }

  maxLiesAdd(summand) {
    this.setState((state) => {
      const isNewGame = checkNewGameStandalone(state.pastGuesses);
      if (isNewGame) {
        const newMaxLies = state.maxLies + summand;
        if (newMaxLies >= 0) {
          return {maxLies: newMaxLies}
        } else {
          return {};
        }
      } else {
        return {maxLiesAddMessage: "Number of lies can only be changed at the start of a round"}
      }
    },
      () => {localStorageSet('maxLies', this.state.maxLies);}
    )
  }
}

function getGameSpecficStateStandalone(isAbsurd) {
  const actualToLiesLeft = null;
  let actualWord = null;
  if (!isAbsurd) {
    actualWord = ALL_ACTUAL[Math.floor(Math.random() * ALL_ACTUAL.length)];
  }
  const gameSpecificState = {
    pastGuesses: [], 
    pastRelativeTrust: [], 
    // relativeToAbsoluteTrust: this.computeRelativeToAbsoluteTrust(useFancyTrust, [], maxLies),
    currentGuess: '', 
    actualToLiesLeft: actualToLiesLeft,
    actualWord: actualWord, 
    isGivenUp: false,
    message: '',
    maxLiesAddMessage: '',
    satisfaction: null,
    shareCopyStatus: UNSHARED,
  }
  return gameSpecificState;
}

// function computeKeyboardAimStandalone(pastGuesses, pastRelativeTrust, relativeToAbsoluteTrust, maxLies) {
//   letterToAimCounts = {}
//   ALL_LETTERS.forEach((letter) => {
//     letterToAimCounts[letter] = {indexToNumHit: Array(WORD_LENGTH).fill(0), numHitClose: 0, numMiss: 0}})
//   });
//   pastGuesses.forEach((pastGuess) => {
//     const hitCloseSet = new Set();
//     const missSet = new Set();
//     [...pastGuess.guessedWord].forEach((letter, index) => {
//       aim = pastGuess.pattern[index]
//     });
//   });
// }


function computeKeyboardAimStandalone(pastGuesses, pastRelativeTrust, relativeToAbsoluteTrust, numTrustLess, maxLies) { // does not use "this"
  // console.log('computeKeyboardAim');
  // const pastGuesses = this.state.pastGuesses;
  // const pastRelativeTrust = this.state.pastRelativeTrust;
  // const relativeToAbsoluteTrust = this.state.relativeToAbsoluteTrust;
  // const maxLies = this.state.maxLies;
  // console.log('maxLies', maxLies);
  const confidentThreshold = (numTrustLess !== null && numTrustLess < maxLies ? maxLies - numTrustLess + 1 : maxLies + 1);
  const keyboardAimDetailed = computeKeyboardAimDetailedStandalone(pastGuesses, pastRelativeTrust, relativeToAbsoluteTrust, confidentThreshold);
  // console.log('keyboardAimDetailed', keyboardAimDetailed)

  const keyboardAimSummary = {}
  for (const letter in keyboardAimDetailed) {
    const letterAim = keyboardAimDetailed[letter];
    const numHitByIndex = letterAim.numHitByIndex;
    const numHitClose = letterAim.numHitClose;
    const numMiss = letterAim.numMiss;
    let maxHit = 0;
    // let totalClose = numClose;
    numHitByIndex.forEach((count, index) => {
      if (count > maxHit) {maxHit = count;}
      // totalClose += count;
    })
    let highMarks = {1: BLANK, [confidentThreshold]: BLANK};
    for (const threshold in highMarks) {
      if (maxHit >= threshold) {highMarks[threshold] = HIT;}
      else if (numHitClose >= threshold) {highMarks[threshold] = CLOSE;}
      else if (numMiss >= threshold) {highMarks[threshold] = MISS;}
    }
    keyboardAimSummary[letter] = [highMarks[1], highMarks[confidentThreshold]];
  }
  return keyboardAimSummary;
}

function computeKeyboardAimDetailedStandalone(pastGuesses, pastRelativeTrust, relativeToAbsoluteTrust, confidentThreshold) { // doesn't use "this" // I think this doesn't need to be separated from computeKeyboardAimStandalone after all
  const keyboardAimDetailed = {};
  ALL_LETTERS.forEach((letter) => {keyboardAimDetailed[letter] = {numHitByIndex: Array(WORD_LENGTH).fill(0), numHitClose: 0, numMiss: 0}})
  pastGuesses.forEach((wordInfo, rowNum) => {
    // console.log('relativeToAbsoluteTrust', relativeToAbsoluteTrust)
    const trust = ((pastRelativeTrust === null) ? UNSURE : relativeToAbsoluteTrust[pastRelativeTrust[rowNum]]);
    // const trust = relativeToAbsoluteTrust[pastRelativeTrust[rowNum]];
    // const weightConversion = {[DISTRUST]: 0, [UNSURE]: 1, [CONFIDENT]: 2};
    const weight = {[DISTRUST]: 0, [UNSURE]: 1, [CONFIDENT]: confidentThreshold}[trust];
    if ((trust === UNSURE) || (trust === CONFIDENT)) {
      const uniqueLetterAim = {};
      for (const i in wordInfo.guessedWord) {
        const letter = wordInfo.guessedWord[i];
        const aim = wordInfo.pattern[i];
        // console.log('aim', i, wordInfo.guessedWord[i], wordInfo.pattern)
        if (aim === HIT) {keyboardAimDetailed[letter].numHitByIndex[i] += weight;}
        if (letter in uniqueLetterAim) {
          if (higherAim(aim, uniqueLetterAim[letter])) {uniqueLetterAim[letter] = aim;}
        } else {
          uniqueLetterAim[letter] = aim;
        }
      }
      for (const letter in uniqueLetterAim)
      {
        const aim = uniqueLetterAim[letter];
        // console.log('trust', trust, 'weight', weight)
        if (aim === HIT || aim === CLOSE) {keyboardAimDetailed[letter].numHitClose += weight;}
        else if (aim === MISS) {keyboardAimDetailed[letter].numMiss += weight;}
        // else if (aim === HIT) {}
        else {console.log("should not reach this line of code");}
      }
    }
  })
  return keyboardAimDetailed;
}

function checkHardHarderModeStandalone(currentGuess, pastGuesses, whichHardMode, maxLies) { // doesn't use this
  // console.log("checkHardHarderModeStandalone(currentGuess, pastGuesses, whichHardMode, maxLies)", currentGuess, pastGuesses, whichHardMode, maxLies)
  if (whichHardMode === NOT_HARD_MODE) {
    return [true, null, null];
  } else if (whichHardMode === HARD_MODE) {
    const hitUnsatisfied = Array(WORD_LENGTH); // position in word to letter to number of past guesses in which that letter appears as HIT (but does not appear in this position in currentGuess)
    for (let i = 0; i < WORD_LENGTH; i++) {
      hitUnsatisfied[i] = {};
    }
    const closeUnsatisfied = {}; // letter to number of past guesses where the number of HIT or CLOSE appearances of that letter exceeds the number in the currentGuess
    const currentGuessLetterCount = {};
    [...currentGuess].forEach((letter) => {
      setDefaultThenAdd(currentGuessLetterCount, letter, 0, 1);
    })
    pastGuesses.forEach((pastGuess) => {
      const numAppearancesInPastWord = {};
      [...pastGuess.pattern].forEach((aim, index) => {
        const currentLetter = currentGuess[index];
        const pastLetter = pastGuess.guessedWord[index];
        if (aim === HIT || aim === CLOSE) {
          setDefaultThenAdd(numAppearancesInPastWord, pastLetter, 0, 1);
        }
        if (aim === HIT) {
          if (currentLetter !== pastLetter) {
            setDefaultThenAdd(hitUnsatisfied[index], pastLetter, 0, 1);
          }
        }
      });
      for (const letter in numAppearancesInPastWord) {
        const pastCount = numAppearancesInPastWord[letter];
        const currentCount = getDefault(currentGuessLetterCount, letter, 0);
        if (pastCount > currentCount) {
          setDefaultThenAdd(closeUnsatisfied, letter, 0, 1);
        }
      }
    });
    let satisfiesHardMode = true;
    let message = null;
    hitUnsatisfied.forEach((letterToNumUnsatisfied, index) =>{
      for (const letter in letterToNumUnsatisfied) {
        const numUnsatisfied = letterToNumUnsatisfied[letter];
        // console.log('numUnsatisfied', letter, numUnsatisfied);
        if (satisfiesHardMode && numUnsatisfied > maxLies) {
          satisfiesHardMode = false;
          message = getOrdinal(index + 1) + " letter must be " + letter.toUpperCase();
        }
      }
    });
    for (const letter in closeUnsatisfied) {
      const numUnsatisfied = closeUnsatisfied[letter];
      // console.log('numUnsatisfied', letter, numUnsatisfied);
      if (satisfiesHardMode && numUnsatisfied > maxLies) {
        const currentCount = getDefault(currentGuessLetterCount, letter, 0);
        satisfiesHardMode = false;
        message = "Must contain " + (currentCount === 0 ? "" : "another ") + letter.toUpperCase();
      }
    }
    // console.log("hard mode", hitUnsatisfied, closeUnsatisfied)
    return [satisfiesHardMode, null, message];
    // return [false, null, "hard mode not properly implemented yet"];
    // // first version (for the harder version of hard mode)
    // console.log("not implemented");
    // // const keyboardAimDetailed = computeKeyboardAimDetailedStandalone(pastGuesses, null, null, maxLies);
    // // console.log('keyboardAimDetailed', keyboardAimDetailed);
    // const hitUnsatisfied = Array(WORD_LENGTH).fill({}); // position in word to letter to number of past guesses in which that letter appears as HIT (but does not appear in this position in currentGuess)
    // const closeUnsatisfied = {}; // letter to number of past guesses where the number of HIT or CLOSE appearances of that letter exceeds the number in the currentGuess
    // const currentGuessLetterCount = {};
    // [...currentGuess].forEach((letter) => {
    //   setDefaultThenAdd(currentGuessLetterCount, letter, 0, 1);
    // })
    // pastGuesses.forEach((pastGuess) => {
    //   const numAppearancesInPastWord = {};
    //   [...pastGuess.pattern].forEach((aim, index) => {
    //     const currentLetter = currentGuess[index];
    //     const pastLetter = pastGuess.guessedWord[index];
    //     if (aim === HIT || aim === CLOSE) {
    //       setDefaultThenAdd(numAppearancesInPastWord, pastLetter, 0, 1);
    //     }
    //     if (aim === HIT) {
    //       if (currentLetter !== pastLetter) {
    //         setDefaultThenAdd(hitUnsatisfied[index], pastLetter, 0, 1);
    //       }
    //     }
    //   });
    //   for (const letter in numAppearancesInPastWord) {
    //     const pastCount = numAppearancesInPastWord[letter];
    //     const currentCount = getDefault(currentGuessLetterCount, letter, 0);
    //     if (pastCount > currentCount) {
    //       setDefaultThenAdd(closeUnsatisfied, letter, 0, 1);
    //     }
    //   }
    // });
    // return [false, null, "hard mode not properly implemented yet"];
  // } else if (whichHardMode === HARD_MODE || whichHardMode === EVEN_HARDER_MODE) {
  } else if (whichHardMode === EVEN_HARDER_MODE) {
    const [numUnsatisfied, satisfaction] = computeSatisfactionStandalone(currentGuess, pastGuesses);
    if (numUnsatisfied <= maxLies) {
      return [true, null, null];
    } else {
      // const message = numUnsatisfied + " clue(s) are unsatisfied";
      // const message = "Guess contradicts " + numUnsatisfied + " clue" + (numUnsatisfied == 1 ? "" : "s");
      const message = numUnsatisfied + " " + (numUnsatisfied === 1 ? "clue is" : "clues are") + " unsatisfied";
      // const message = "More than " + maxLies + " " + (maxLies === 1 ? "clue is" : "clues are") + " unsatisfied";
      return [false, satisfaction, message];
    }
  } else {
    console.log("should not reach this line");
  }
}

function checkAllSatisfiesHardHarderModeStandalone(pastGuesses, whichHardMode, maxLies) {
  // console.log("checkAllSatisfiesHardHarderModeStandalone(pastGuesses, whichHardMode, maxLies)", pastGuesses, whichHardMode, maxLies);
  // console.log("checking whichHardMode", whichHardMode);
  // pastGuesses.forEach((pastGuess, index) => {
  for (let index in pastGuesses) {
    const pastGuess = pastGuesses[index];
    // console.log("checking", pastGuess.guessedWord);
    const [satisfiesHardMode, /*satisfaction*/, /*message*/] = checkHardHarderModeStandalone(pastGuess.guessedWord, pastGuesses.slice(0, index), whichHardMode, maxLies);
    // console.log("satisfiesHardMode", satisfiesHardMode);
    if (!satisfiesHardMode) {
      // console.log("pastGuess", pastGuess.guessedWord, index);
      return false;
    }
  }
  // console.log("passed checks");
  return true;
}

function computeSatisfactionStandalone(currentGuess, pastGuesses) {
  let numUnsatisfied = 0;
  let satisfaction = [];
  // let unsatsifedSet = new Set();
  pastGuesses.forEach((pastGuess, index) => {
    let lettersSatisfied = "";
    const hypotheticalPattern = computePattern(currentGuess, pastGuess.guessedWord);
    if (pastGuess.pattern === hypotheticalPattern) {
      lettersSatisfied = ALL_SATISFIED;
    } else {
      // console.log("pattern", hypotheticalPattern, pastGuess.pattern);
      let wordIsUnsatisfied = false;
      // unsatsifedSet.add(index);
      [...pastGuess.pattern].forEach((letterAim, i) => {
        const hypotheticalAim = hypotheticalPattern[i];
        // if (letterAim === hypotheticalAim || (whichHardMode === HARD_MODE && higherAim(hypotheticalAim, letterAim))) { // this doesn't do the right thing for hard mode (it's okay for even harder mode) if the currentGuess has the same letter twice, and the later instance is in the correct place
        if (letterAim === hypotheticalAim) { // this doesn't do the right thing for hard mode (it's okay for even harder mode) if the currentGuess has the same letter twice, and the later instance is in the correct place
            lettersSatisfied += LETTER_SATISFIED;
        } else {
          lettersSatisfied += LETTER_UNSATIFIED;
          wordIsUnsatisfied = true;
        }
      })
      if (wordIsUnsatisfied) {
        numUnsatisfied += 1;
      }
    }
    satisfaction.push(lettersSatisfied);
  })
  return [numUnsatisfied, satisfaction];
}

function getGameboardEmoji(pastGuesses, useDarkMode, useHighContrast) {
  const isWin = checkWinStandalone(pastGuesses);
  const actualWord = (isWin ? pastGuesses[pastGuesses.length - 1].guessedWord : null);
  const [/*numUnsatisfied*/, satisfaction] = (isWin ? computeSatisfactionStandalone(actualWord, pastGuesses) : [null, null]);
  const aimToEmoji = DARK_CONTRAST_AIM_TO_EMOJI[useDarkMode][useHighContrast];
  // console.log("aimToEmoji", aimToEmoji);
  let s = ''
  pastGuesses.forEach((pastGuess, index) => {
    const isLie = (satisfaction !== null && satisfaction[index] !== ALL_SATISFIED);
    [...pastGuess.pattern].forEach((aim) => {
      s += aimToEmoji[aim];
    })
    if (isLie) {
      s += " 🤥 LIE"
    }
    if (pastGuess.pattern === ALL_HIT) {
      s += "\nThe secret word was " + pastGuess.guessedWord.toUpperCase() + ".";
    }
    s += '\n';
  })
  if (!isWin) {
    s += Array(WORD_LENGTH).fill(aimToEmoji[BLANK]).join('') + " Gave Up\n";
  }
  return s;
}

function checkWinStandalone(pastGuesses) {
  // console.log("pastGuesses", pastGuesses);
  return (pastGuesses.length > 0) && (pastGuesses[pastGuesses.length - 1].pattern === ALL_HIT);
}

function checkNewGameStandalone(pastGuesses) {
  // console.log("pastGuesses", pastGuesses);
  return (pastGuesses.length === 0);
}

function miniMemo(fn) {
  // console.log("miniMemo setup");
  let savedArgs = null;
  let savedValue = null;
  function g(...args) {
    // console.log("miniMemo outer", savedArgs, args);
    if (savedArgs === null) {
      // console.log("miniMemo inner (null)");
      savedArgs = args;
      savedValue = fn(...args);
      return savedValue;
    }
    for (let i = 0; i < savedArgs.length; i++) {
      if (savedArgs[i] !== args[i]) {
        // console.log("miniMemo inner", i);
        savedArgs = args;
        savedValue = fn(...args);
        return savedValue;
      }
    }
    // if (!(savedArgs == args)) {
    //   console.log("miniMemo inner");
    //   savedArgs = args;
    //   savedValue = fn(...args);
    // }
    return savedValue;
  }
  return g;
}

// class SaveRelativeToAbsoluteTrust extends React.PureComponent {
//   constructor(props) {
//     super(props);
//     console.log("constructing SaveRelativeToAbsoluteTrust");
//   }

//   componentDidUpdate() {
//     console.log("SaveRelativeToAbsoluteTrust did update");
//   }

//   render() {
//     console.log("rendering SaveRelativeToAbsoluteTrust");
//     return null;
//   }

  
//   computeRelativeToAbsoluteTrust() {
//     const useFancyTrust = this.props.useFancyTrust;
//     const pastRelativeTrust = this.props.pastRelativeTrust;
//     const maxLies = this.props.maxLies;
//     if (useFancyTrust) {
//       let numTrustLess = 0;
//       pastRelativeTrust.forEach((relativeTrust) => {
//         if (relativeTrust === TRUST_LESS) {
//           numTrustLess += 1;
//         }
//       })
//       const relativeToAbsoluteTrust = {};
//       if (numTrustLess < maxLies) {  // should be maxLies
//         relativeToAbsoluteTrust[TRUST_MORE] = UNSURE;
//       } else {
//         relativeToAbsoluteTrust[TRUST_MORE] = CONFIDENT;
//       }
//       if (numTrustLess <= maxLies) {  // should be maxLies
//         relativeToAbsoluteTrust[TRUST_LESS] = DISTRUST;
//       } else {
//         relativeToAbsoluteTrust[TRUST_LESS] = UNSURE;
//       }
//       return relativeToAbsoluteTrust;
//     } else {
//       return {[TRUST_MORE]: CONFIDENT, [TRUST_LESS]: DISTRUST};
//     }
//   }
// }

export default App;
